import api, { handleResponse, handleError } from './api';

const notificationService = {
  /**
   * Get paginated notifications
   * @param {number} page - Page number (1-based)
   * @param {number} pageSize - Items per page
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async getNotifications(page = 1, pageSize = 20) {
    try {
      const response = await api.get(`/notifications?page=${page}&pageSize=${pageSize}`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Get unread notification count
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async getUnreadCount() {
    try {
      const response = await api.get('/notifications/unread-count');
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Mark a single notification as read
   * @param {string} id - Notification ID
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async markAsRead(id) {
    try {
      const response = await api.put(`/notifications/${id}/read`);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Mark all notifications as read
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async markAllAsRead() {
    try {
      const response = await api.put('/notifications/read-all');
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },
};

export default notificationService;
